"use client";
import React, { useMemo, memo } from "react";

import Cards from "../content/cards";
import { useSelector } from "react-redux";
import { isContentAllowedForAgeRange } from "@/helpers/ageRange.utils";

const PentaBanners = memo(
  ({
    bannerTitle,
    bannerDescription,
    bannerBackground,
    bannerItems,
    preserveOrder = false,
    nextPlayGuide = null,
  }) => {
    const _ageRange = useSelector((state) => state.Auth.ageRange) || 120;

    const { hasData, filteredItems } = useMemo(() => {
      const filtered = bannerItems.filter((x) =>
        isContentAllowedForAgeRange(x.content?.ageRange, _ageRange, {
          allowEmpty: false,
        })
      );
      return {
        hasData: filtered.length > 0,
        filteredItems: filtered,
      };
    }, [bannerItems, _ageRange]);

    if (!hasData) return null;

    return (
      <>
        <div className="md:container mx-auto max-w-full hidden lg:flex flex-col">
          <div
            className={`flex h-[90%] min-h-[400px] items-start pt-2 rounded-3xl border-[3px] border-solid border-[#F5F5F5] max-w-[100%] relative overflow-hidden`}
            style={{
              backgroundColor: "black",
              aspectRatio: "131/36",
            }}
          >
            <div className="absolute inset-0 rounded-3xl overflow-hidden">
              <img
                src={bannerBackground}
                alt={bannerTitle}
                loading="eager"
                style={{
                  objectFit: "contain",
                  objectPosition: "20% 50%",
                }}
              />
            </div>
            <div className="flex flex-col justify-start h-full p-10 text-[#F0F0F0] relative z-10">
              <h3 className="font-black text-[52px] mb-2">{bannerTitle}</h3>
              {/* <h5 className="font-[700] text-[32.5px] mb-2">
                {bannerDescription}
              </h5> */}
              {/* <div>
              <CustomButton
                label="تماشا کن"
                color="primary"
                textColor="text-primary-white"
                rightIcon={<WatchPlayIcon />}
              />
            </div> */}
            </div>
          </div>
          <div className="flex justify-center relative mt-[-10rem] w-full">
            <Cards
              items={filteredItems}
              categoryName={bannerTitle}
              showTitle={false}
              hasExpand={false}
              isSwiper={true}
              type="movie"
              noShadow={true}
              preserveOrder={preserveOrder}
              nextPlayGuide={nextPlayGuide}
            />
          </div>
        </div>
        <div className="flex lg:hidden">
          <Cards
            items={filteredItems}
            categoryName={bannerTitle}
            showTitle={true}
            hasExpand={false}
            isSwiper={true}
            type="movie"
            preserveOrder={preserveOrder}
            nextPlayGuide={nextPlayGuide}
          />
        </div>
      </>
    );
  }
);

PentaBanners.displayName = "PentaBanners";

export default PentaBanners;
